module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.shippingModuleIsInstalled('table_rate')) ? _c('div', [_c('h4', {
    staticClass: "group__headline"
  }, [_vm._v("Table Rate")]), _vm._v(" "), (_vm.model.table_rate) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.table_rate.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.table_rate, "enabled", $$v)
      },
      expression: "model.table_rate.enabled"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.table_rate.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.table_rate, "enabled", $$v)
      },
      expression: "model.table_rate.enabled"
    }
  }, [_vm._v("No")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.activeRateGroup),
      callback: function($$v) {
        _vm.activeRateGroup = $$v
      },
      expression: "activeRateGroup"
    }
  }, _vm._l((_vm.tablerates), function(rateGroup, rateIndex) {
    return _c('el-collapse-item', {
      key: rateIndex,
      attrs: {
        "title": rateGroup.name,
        "name": rateIndex
      }
    }, [(_vm.activeRateGroup == rateIndex) ? _c('div', [_c('el-form-item', {
      attrs: {
        "label": "Name"
      }
    }, [_c('el-input', {
      model: {
        value: (rateGroup.name),
        callback: function($$v) {
          _vm.$set(rateGroup, "name", $$v)
        },
        expression: "rateGroup.name"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Country"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (rateGroup.country),
        expression: "rateGroup.country"
      }],
      staticClass: "select",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(rateGroup, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.countries), function(country) {
      return _c('option', {
        key: country.id,
        domProps: {
          "value": country.id
        }
      }, [_vm._v("\n                                " + _vm._s(country.name) + "\n                            ")])
    }), 0)]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Maximum weight"
      }
    }, [_c('el-input', {
      model: {
        value: (rateGroup.max_weight),
        callback: function($$v) {
          _vm.$set(rateGroup, "max_weight", $$v)
        },
        expression: "rateGroup.max_weight"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Time"
      }
    }, [_c('el-input', {
      model: {
        value: (rateGroup.time),
        callback: function($$v) {
          _vm.$set(rateGroup, "time", $$v)
        },
        expression: "rateGroup.time"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Postcode start"
      }
    }, [_c('el-input', {
      model: {
        value: (rateGroup.cep_start),
        callback: function($$v) {
          _vm.$set(rateGroup, "cep_start", $$v)
        },
        expression: "rateGroup.cep_start"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Postcode end"
      }
    }, [_c('el-input', {
      model: {
        value: (rateGroup.cep_end),
        callback: function($$v) {
          _vm.$set(rateGroup, "cep_end", $$v)
        },
        expression: "rateGroup.cep_end"
      }
    })], 1), _vm._v(" "), _vm._l((rateGroup.rates), function(rate, index) {
      return _c('el-form-item', {
        key: index,
        attrs: {
          "label": "Rate"
        }
      }, [_c('el-row', {
        attrs: {
          "gutter": 5
        }
      }, [_c('el-col', {
        attrs: {
          "span": 5
        }
      }, [_c('el-input', {
        attrs: {
          "placeholder": "From"
        },
        model: {
          value: (rate.from),
          callback: function($$v) {
            _vm.$set(rate, "from", $$v)
          },
          expression: "rate.from"
        }
      }, [_c('template', {
        slot: "prepend"
      }, [_vm._v("Gram")])], 2)], 1), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 5
        }
      }, [_c('el-input', {
        attrs: {
          "placeholder": "Rate"
        },
        model: {
          value: (rate.rate),
          callback: function($$v) {
            _vm.$set(rate, "rate", $$v)
          },
          expression: "rate.rate"
        }
      }, [_c('template', {
        slot: "prepend"
      }, [_vm._v("Price $")])], 2)], 1), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 11
        }
      }, [_c('el-button', {
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.removeRate(rateIndex, rate)
          }
        }
      }, [_vm._v("Delete")])], 1)], 1)], 1)
    }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
      on: {
        "click": function($event) {
          return _vm.addRate(rateIndex)
        }
      }
    }, [_vm._v("New rate")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.removeRateGroup(rateIndex)
        }
      }
    }, [_vm._v("Remove rate group")])], 1)], 2) : _vm._e()])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "u__margin-top"
  }, [_c('el-button', {
    on: {
      "click": _vm.addRateGroup
    }
  }, [_vm._v("Add new rate group")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveTableRate
    }
  }, [_vm._v("Save Table Rate")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.shippingModuleIsInstalled('flatrate')) ? _c('div', [_c('h4', {
    staticClass: "group__headline mt-20"
  }, [_vm._v("Flat Rate")]), _vm._v(" "), (_vm.model.flatrate) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.flatrate.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.flatrate, "enabled", $$v)
      },
      expression: "model.flatrate.enabled"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.flatrate.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.flatrate, "enabled", $$v)
      },
      expression: "model.flatrate.enabled"
    }
  }, [_vm._v("No")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "u__margin-top"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveFlatRate
    }
  }, [_vm._v("Save Flat Rate")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.shippingModuleIsInstalled('fedex')) ? _c('div', [_c('h4', {
    staticClass: "group__headline mt-20"
  }, [_vm._v("Fedex")]), _vm._v(" "), (_vm.model.fedex) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.fedex.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.fedex, "enabled", $$v)
      },
      expression: "model.fedex.enabled"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.fedex.enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.fedex, "enabled", $$v)
      },
      expression: "model.fedex.enabled"
    }
  }, [_vm._v("No")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "u__margin-top"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveFedex
    }
  }, [_vm._v("Save Fedex")])], 1)]) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "group__headline mt-20"
  }, [_vm._v("Shipping Discounts")]), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.activeDiscount),
      callback: function($$v) {
        _vm.activeDiscount = $$v
      },
      expression: "activeDiscount"
    }
  }, _vm._l((_vm.shiprules), function(rule, ruleIndex) {
    return _c('el-collapse-item', {
      key: ruleIndex,
      attrs: {
        "title": rule.name,
        "name": ruleIndex
      }
    }, [(_vm.activeDiscount == ruleIndex) ? _c('div', [_c('el-form-item', {
      attrs: {
        "label": "Name"
      }
    }, [_c('el-input', {
      model: {
        value: (rule.name),
        callback: function($$v) {
          _vm.$set(rule, "name", $$v)
        },
        expression: "rule.name"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Discountend shipping value"
      }
    }, [_c('el-input', {
      model: {
        value: (rule.discounted_shipping),
        callback: function($$v) {
          _vm.$set(rule, "discounted_shipping", $$v)
        },
        expression: "rule.discounted_shipping"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Minimum order value"
      }
    }, [_c('el-input', {
      model: {
        value: (rule.free_shipping),
        callback: function($$v) {
          _vm.$set(rule, "free_shipping", $$v)
        },
        expression: "rule.free_shipping"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Maximum order value (Optional)"
      }
    }, [_c('el-input', {
      model: {
        value: (rule.free_shipping_max),
        callback: function($$v) {
          _vm.$set(rule, "free_shipping_max", $$v)
        },
        expression: "rule.free_shipping_max"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Delivery type"
      }
    }, [_c('el-input', {
      model: {
        value: (rule.ratekey),
        callback: function($$v) {
          _vm.$set(rule, "ratekey", $$v)
        },
        expression: "rule.ratekey"
      }
    })], 1), _vm._v(" "), _vm._l((rule.location), function(loc, index) {
      return _c('el-form-item', {
        key: index,
        attrs: {
          "label": "Location",
          "rules": {
            required: true,
            message: 'location can not be null',
            trigger: 'blur',
          }
        }
      }, [_c('el-col', {
        attrs: {
          "span": 11
        }
      }, [_c('div', {
        staticClass: "relative"
      }, [_c('label', {
        staticClass: "inline-block text-xs text-neutral-300 bg-white ml-px absolute top-0 left-2.5 z-10 px-1 transform -translate-y-1/2"
      }, [_vm._v("Country")]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (loc.country),
          expression: "loc.country"
        }],
        staticClass: "select",
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(loc, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, function($event) {
            return _vm.getZonesOnSelectChange($event)
          }]
        }
      }, _vm._l((_vm.countries), function(country) {
        return _c('option', {
          key: country.id,
          domProps: {
            "value": country.id.toString()
          }
        }, [_vm._v("\n                                    " + _vm._s(country.name) + "\n                                ")])
      }), 0)]), _vm._v(" "), (loc.country) ? _c('div', {
        staticClass: "relative mt-4"
      }, [_c('label', {
        staticClass: "inline-block text-xs text-neutral-300 bg-white ml-px absolute top-0 left-2.5 z-10 px-1 transform -translate-y-1/2"
      }, [_vm._v("State")]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (loc.zone),
          expression: "loc.zone"
        }],
        staticClass: "select",
        attrs: {
          "disabled": _vm.isFetchingZones
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(loc, "zone", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.mappedZones[loc.country]), function(zone) {
        return _c('option', {
          key: zone.id,
          domProps: {
            "value": zone.id.toString()
          }
        }, [_vm._v("\n                                    " + _vm._s(zone.name) + "\n                                ")])
      }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "relative mt-4"
      }, [_c('label', {
        staticClass: "inline-block text-xs text-neutral-300 bg-white ml-px absolute top-0 left-2.5 z-10 px-1 transform -translate-y-1/2"
      }, [_vm._v("City")]), _vm._v(" "), _c('el-input', {
        model: {
          value: (loc.city),
          callback: function($$v) {
            _vm.$set(loc, "city", $$v)
          },
          expression: "loc.city"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "relative mt-4"
      }, [_c('label', {
        staticClass: "inline-block text-xs text-neutral-300 bg-white ml-px absolute top-0 left-2.5 z-10 px-1 transform -translate-y-1/2"
      }, [_vm._v("District")]), _vm._v(" "), _c('el-input', {
        model: {
          value: (loc.bairro),
          callback: function($$v) {
            _vm.$set(loc, "bairro", $$v)
          },
          expression: "loc.bairro"
        }
      })], 1)]), _vm._v(" "), _c('el-col', {
        staticClass: "flex justify-end",
        attrs: {
          "span": 11
        }
      }, [_c('el-button', {
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.removeLocation(ruleIndex, index)
          }
        }
      }, [_vm._v("Delete location")])], 1)], 1)
    }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
      on: {
        "click": function($event) {
          return _vm.addLocation(ruleIndex)
        }
      }
    }, [_vm._v("Add new location")])], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "mt-4"
    }, [_c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.removeShipDiscount(ruleIndex)
        }
      }
    }, [_vm._v("Remove discount")])], 1)], 2) : _vm._e()])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "u__margin-top"
  }, [_c('el-button', {
    on: {
      "click": _vm.addDiscount
    }
  }, [_vm._v("New discount")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDiscounts
    }
  }, [_vm._v("Save discounts")])], 1), _vm._v(" "), (_vm.model.shipping_discounts && _vm.model.shipping_discounts.property) ? _c('div', [_c('h4', {
    staticClass: "group__headline mt-20"
  }, [_vm._v("Property related free shipping (Free shipping only if all order items have this property set)")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Property name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.shipping_discounts.property),
      callback: function($$v) {
        _vm.$set(_vm.model.shipping_discounts, "property", $$v)
      },
      expression: "model.shipping_discounts.property"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "u__margin-top"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.savePropertyRelatedFreeShipping
    }
  }, [_vm._v("Save Property related free shipping")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4c9de3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shipping.vue
// module id = 553
// module chunks = 1